const langList = {
    en: {
        "first_name": "First Name",
        "family_name": "Family Name",
        "tenant_monitoring": "Tenant Monitoring",
        "building_no": "Building No",
        "building_name": "Building Name",
        "street_name": "Street Name",
        "street_no": "Street No",
        "city": "City",
        "apartment_no": "Apartment No",
        "postal_code": "Postal Code",
        "amount": "Amount",
        "currency_type": "Currency Type",
        "actions": "Actions",
        "updated_at": "Updated At",
        "apartment_list": "Apartment List",
        "statistics": "Statistics",
        "tenant_list": "Tenant List",
        "add_apartment": "Add New Apartment",
        "cancel": "Cancel",
        "add" : "Add",
        "edit" : "Edit",
        "delete" : "Delete",
        "save" : "Save",
        "search" : "Search",
        "operation_success" : "Operation Success",
        "operation_failed" : "Operation Failed",
        "user_name_or_password_is_wrong" : "Username or password is incorrect, please try again!",
        "error": "Error",
        "error_permission": "You don't have permission to view this page",
        "total_records": "Total records",
        "site_name": "Site Name",
        "sure_to_delete": "Are you sure to delete?",
        "delete_denied": "Delete operation could not be performed",
        "delete_success": "Delete operation was successful",
        "success": "Success",
        "clear": "Clear",
        "edit_apartment": "Edit apartment information",
        "phone" : "Phone",
        "email" : "Email",
        "contract_start_date" : "Contract Start Date",
        "contract_end_date" : "Contract End Date",
        "contract_type" : "Contract Type",
        "contract_status": "Contract Status",
        "terminated_date": "Terminated Date",
        "tenant_lease_list": "Tenant and Lease List",
        "active": "Active",
        "terminated": "Terminated",
        "apartment_status": "Apartment Status",
        "reserved": "Reserved",
        "empty": "Empty",
        "lease_contract" : "Lease Contract",
        "address": "Address",
        "slider1_title":"Manage your tenants easily.",
        "slider2_title":"All records on one screen.",
        "slider3_title":"Safe and fast login.",
        "slider1_description":"Track all your properties from a single panel and use your time efficiently.",
        "slider2_description":"Reports, payments and contracts all together, always accessible.",
        "slider3_description":"Your data is protected, your entries are always safe.",
        "welcome":"Welcome",
        "login_into_user_account":"Login into your account",
        "username_or_email":"Username/e-Mail",
        "password":"Password",
        "forgot_password":"Forgot Paswword",
        "remember_me":"Remember Me",
        "enter":"Enter",
        "exit":"Exit",
        "address_copy_error": "Could not copy address",
        "address_copied": "Address copied successfully",
        "add_new_tenant": "Add new tenant",
        "first_name_required": "First name is required",
        "family_name_required": "Family name is required",
        "phone_required": "Phone is required",
        "email_required": "Email is required",
        "edit_tenant": "Edit tenant information",
        "edit_contract": "Edit contract information",
        "add_new_contract": "Add new contract",
        "tenant_person" : "Tenant",
        "apartment_required": "Apartment is required",
        "select_apartment": "Select Apartment",
        "apartment": "Apartment",
        "select_currency_type": "Select Currency Type",
        "contract_start_date_required": "Contract start date is required",
        "contract_end_date_required": "Contract end date is required",
        "currency_type_required": "Currency type is required",

    },
    ar: {
        "first_name": "الاسم الأول",
        "family_name": "اسم العائلة",
        "tenant_monitoring" : "متابعة المستأجرين",
        "building_no": "رقم البناء",
        "building_name": "اسم البناء",
        "street_name": "اسم الشارع",
        "street_no": "رقم الشارع",
        "city": "المدينة",
        "apartment_no": "رقم الشقة",
        "postal_code": "الرمز البريدي",
        "amount": "المبلغ الإجمالي",
        "currency_type": "نوع العملة",
        "actions": "إجراءات",
        "updated_at": "آخر تحديث",
        "apartment_list": "قائمة الشقق",
        "statistics" : "الاحصائيات",
        "tenant_list": "قائمة المستأجرين",
        "add_apartment": "أضف معلومات شقة جديدة",
        "cancel": "إلغاء",
        "add" : "إضافة",
        "edit": "تعديل",
        "update": "تحديث",
        "save" : "حفظ",
        "operation_success" : "نجحت العملية",
        "user_name_or_password_is_wrong" : "اسم المستخدم أو كلمة المرور غير صحيحة، يرجى المحاولة مرة أخرى!",
        "error" : "خطأ",
        "error_permission" : "ليس لديك صلاحية لعرض هذه الصفحة.",
        "total_records" :  "إجمالي السجلات",
        "site_name": "اسم المجمع",
        "sure_to_delete": "هل أنت متأكد من الحذف؟",
        "delete_denied" : "تعذر تنفيذ عملية الحذف.",
        "delete_success" : "تم الحذف بنجاح.",
        "success": "نجاح",
        "search": "بحث",
        "clear" : "مسح",
        "edit_apartment": "تعديل معلومات الشقة",
        "phone": "رقم الهاتف",
        "email": "البريد الإلكتروني",
        "contract_status": "حالة العقد",
        "contract_start_date": "تاريخ بدء العقد",
        "contract_end_date": "تاريخ انتهاء العقد",
        "terminated_date" : "تاريخ الانتهاء",
        "tenant_lease_list": "قائمة المستأجرين والعقود",
        "active" : "ساري",
        "terminated": "منتهي",
        "apartment_status": "حالة الشقة",
        "reserved": "مستأجرة",
        "empty": "فارغة",
        "lease_contract": "عقد إيجار",
        "address": "الموقع",
        "slider1_title": "إدارة المستأجرين لديك بسهولة.",
        "slider2_title": "جميع السجلات على شاشة واحدة.",
        "slider3_title": "تسجيل الدخول بشكل آمن وسريع.",
        "slider1_description": "تتبع جميع ممتلكاتك من لوحة تحكم واحدة واستخدم وقتك بكفاءة.",
        "slider2_description": "جميع التقارير والمدفوعات والعقود يمكن الوصول إليها بأي وقت.",
        "slider3_description": "بياناتك محمية، ومدخلاتك آمنة دائمًا.",
        "welcome":"مرحباً",
        "login_into_user_account":"تسجيل الدخول إلى حساب المستخدم",
        "username_or_email":"اسم المستخدم/البريد الإلكتروني",
        "password":"كلمة المرور",
        "forgot_password":"نسيت كلمة السر",
        "remember_me":"تذكرنى",
        "enter":"دخول",
        "exit":"خروج",
        "address_copy_error": "خطأ في نسخ العنوان",
        "address_copied": "تم نسخ العنوان",
        "add_new_tenant": "إضافة مستأجر جديد",
        "first_name_required": "الاسم الأول مطلوب",
        "family_name_required": "اسم العائلة مطلوب",
        "phone_required": "رقم الهاتف مطلوب",
        "email_required": "البريد الإلكتروني مطلوب",
        "edit_tenant": "تعديل معلومات المستأجر",
        "edit_contract": "تعديل معلومات العقد",
        "add_new_contract": "إضافة عقد جديد",
        "tenant_person": "المستأجر",
        "apartment_required": "الشقة مطلوبة",
        "select_apartment": "اختر الشقة",
        "apartment": "الشقة",
        "select_currency_type": "اختر نوع العملة",
        "contract_start_date_required": "تاريخ بدء العقد مطلوب",
        "contract_end_date_required": "تاريخ انتهاء العقد مطلوب",
        "currency_type_required": "نوع العملة مطلوب",

    },
    tr: {
        "first_name": "Adı",
        "family_name": "Soyadı",
        "tenant_monitoring": "Kiracı Takibi",
        "building_no": "Bina No",
        "building_name": "Bina Adı",
        "street_name": "Sokak Adı",
        "street_no": "Sokak No",
        "city": "Şehir",
        "apartment_no": "Daire No",
        "postal_code": "Posta Kodu",
        "amount": "Toplam Tutar",
        "currency_type": "Para Birimi",
        "actions": "İşlemler",
        "updated_at": "Güncellenme Tarihi",
        "apartment_list": "Daire Listesi",
        "statistics": "İstatistikler",
        "tenant_list": "Kiracı Listesi",
        "add_apartment": "Yeni Daire Ekle",
        "cancel": "İptal",
        "add" : "Ekle",
        "edit" : "Düzenle",
        "update": "Güncelle",
        "delete" : "Sil",
        "save" : "Kaydet",
        "search" : "Ara",
        "operation_success" : "İşlem Başarılı",
        "user_name_or_password_is_wrong" : "Kullanıcı adı veya şifre hatalı, tekrar deneyiniz!",
        "error": "Hata",
        "error_permission": "Bu sayfayı görmeye yetkiniz bulunmamaktadır.",
        "total_records": "Toplam kayıt",
        "site_name": "Site Adı",
        "sure_to_delete": "Silmek istediğinize emin misiniz?",
        "delete_denied" : "Silme işlemi gerçekleştirilemedi.",
        "delete_success" : `Silme işlemi başarılı.`,
        "success" : "Başarılı",
        "clear" : "Temizle",
        "edit_apartment" : "Daire bilgilerini düzenle",
        "phone" : "Telefon",
        "email": "E-posta",
        "contract_start_date": "Sözleşme Başlangıç Tarihi",
        "contract_end_date": "Sözleşme Bitiş Tarihi",
        "contract_status" : "Sözleşme Durumu",
        "terminated_date": "Bitiş Tarihi",
        "tenant_lease_list" : "Kiracı ve Sözleşme Listesi",
        "active": "Aktif",
        "terminated" : "Bitmiş",
        "apartment_status": "Daire Durumu",
        "reserved": "Rezerve",
        "empty": "Boş",
        "lease_contract": "Kira Sözleşme",
        "address": "Adres",
        "slider1_title": "Kiracılarını kolayca yönet.",
        "slider2_title": "Tüm kayıtlar tek ekranda.",
        "slider3_title": "Güvenli ve hızlı giriş.",
        "slider1_description": "Tüm mülklerini tek panelden takip et, zamanını verimli kullan.",
        "slider2_description": "Raporlar, ödemeler ve sözleşmeler bir arada, her zaman ulaşılabilir.",
        "slider3_description": "Verilerin koruma altında, girişler her zaman güvenli.",
        "welcome":"Hoşgeldiniz",
        "login_into_user_account":"Kullanıcı hesabınıza giriş",
        "username_or_email":"Kullanıcı adı/e-Posta",
        "password":"Şifre",
        "forgot_password":"Şifremi unuttum",
        "remember_me":"Beni Hatırla",
        "enter":"Giriş",
        "exit":"Çıkış",
        "address_copy_error": "Adres kopyalama hatası",
        "address_copied": "Adres kopyalandı",
        "add_new_tenant": "Yeni Kiracı Ekle",
        "first_name_required": "İsim zorunludur",
        "family_name_required": "Soyadı zorunludur",
        "phone_required": "Telefon zorunludur",
        "email_required": "E-posta zorunludur",
        "edit_tenant": "Kiracı Bilgilerini Düzenle",
        "edit_contract": "Sözleşme Bilgilerini Düzenle",
        "add_new_contract": "Yeni Sözleşme Ekle",
        "tenant_person": "Kiracı",
        "apartment_required": "Daire zorunludur",
        "select_apartment": "Daire seç",
        "apartment": "Daire",
        "select_currency_type": "Para birimi Seç",
        "contract_start_date_required": "sözleşme başlangıç tarihi zorunludur",
        "contract_end_date_required": "Sözleşme bitiş tarihi zorunludur",
        "currency_type_required": "Para birimi zorunludur",
    }
};

export function language(lang, key) {
    return langList[lang] && langList[lang][key] ? langList[lang][key] : key;
}


// WEBPACK FOOTER //
// ./src/util/language.js